var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"tips"},[_c('span',[_vm._v("客服热线：")]),_c('span',[_vm._v("96345")])])])}]

export { render, staticRenderFns }